export const rolesConfPermissions = {
  methodPaymentsSetting: 'METHOD_PAYMENT',
  licenDashboardResumeSetting: 'RESUME_LICENC_DASHBOARD',
  cotizacionConfSetting: 'COTIZACION_CONF',
  listaEnviosSetting: 'LISTA_ENVIOS_CONF'
};

// nombre de la coleccion ====> settings_conf

export const settingsFunctionsCollection = [
  {
    id: 'METHOD_PAYMENT',
    methods: [
      {
        id: 'REPORTE',
        name: 'Reporte',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      },
      {
        id: 'CLIP',
        name: 'Clip',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      },
      {
        id: 'MERCADO_PAGO',
        name: 'Mercado Pago',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      }
    ]
  },
  {
    id: 'RESUME_LICENC_DASHBOARD',
    methods: [
      {
        id: 'TOTAL_VENTAS',
        id_number: 1,
        name: 'Ventas totales',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      },
      {
        id: 'ENVIOS',
        id_number: 2,
        name: 'Envios',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      },
      {
        id: 'CAJEROS',
        id_number: 3,
        name: 'Cajeros',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      },
      {
        id: 'RESUMEN_PAQUETERIA',
        id_number: 4,
        name: 'Actividad por paqueteria',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      },
      {
        id: 'ENVIO_ESTATISTICS',
        id_number: 5,
        name: 'Resumen envios',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      }
    ]
  },
  {
    id: 'COTIZACION_CONF',
    methods: [
      {
        id: 'INACTIVE_COTIZACION_LIST',
        id_number: 1,
        name: 'Lista inactiva cotizacion',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      }
    ]
  },
  {
    id: 'LISTA_ENVIOS_CONF',
    methods: [
      {
        id: 'LISTA_ENV_NORMAL',
        id_number: 1,
        name: 'Lista envios general',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      },
      {
        id: 'LISTA_ENV_LICENC',
        id_number: 2,
        name: 'Lista envios licenciatarios',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      },
      {
        id: 'LISTA_ENV_ADMIN',
        id_number: 3,
        name: 'Lista envios admins',
        status: 'ACTIVE',
        allowedUserType: [],
        allowedUserRole: []
      }
    ]
  }
];
